import { memo, useEffect, useState } from "react";
import { Button, Divider, Flex, Input, Switch, Table, Image, Dropdown, Pagination, Card } from "antd";
import * as Icon from "@ant-design/icons";
import * as Number from "common/number_format";
import { getAlertItem } from "common/get_alert_item";
import Tags from "components/tag-list";
import { useAppContext } from "context/app";
import { CustomField } from "pages";
import RenderCustomField from "pages/item-detail/RenderCustomField";
import ItemService from "services/item";
import { useNavigate } from "react-router-dom";

const itemService = new ItemService();

function TableListItem({ visibleColumns, loading, items, paging, setPaging, statistic, setSorts }) {
    const { folderList, customFieldList } = useAppContext();
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        setExpandedRowKeys([]);
    }, [items]);

    const handleExpand = async (expanded, item) => {
        const getItem = await itemService.getByID(item.id);

        if (expanded && item.children.length === 0) {
            item.children = getItem.variant?.childs;
        }

        setExpandedRowKeys((prev) => (expanded ? [...prev, item.key] : [...prev.filter((key) => key != item.key)]));
    };

    const renderAllCustomField = () => {
        return customFieldList.map((customField) => ({
            title: customField.name,
            dataIndex: `CustomField_${customField.id}`,
            key: `CustomField_${customField.id}`,
            width: "10%",
            render: (text, record) => {
                if (!record.custom_field || Object.keys(record.custom_field).length === 0) {
                    return "";
                }

                const customFieldValue = record?.custom_field?.[customField.id];
                if (!customFieldValue) return "";

                const data = {
                    ...customField,
                    value: customFieldValue,
                };
                return (
                    <div style={{ overflow: "hidden" }}>
                        <RenderCustomField data={data} />
                    </div>
                );
            },
        }));
    };

    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            width: "15%",
            fixed: "left",
            render: (text, record) => {
                const img =
                    record?.photos && record.photos.length > 0 ? (
                        <Image style={{ borderRadius: "4px" }} width={30} src={record.photos[0].url} />
                    ) : (
                        <Icon.FileImageOutlined style={{ fontSize: "30px" }} />
                    );

                const result = (
                    <Flex gap={10} align="center">
                        {img}
                        <Flex vertical style={{ cursor: "pointer" }} onClick={() => navigate(`/item-detail/${record.id}`)}>
                            <span>{record.name}</span>
                            <span>{record.variant_title}</span>
                        </Flex>
                    </Flex>
                );

                return result;
            },
        },
        {
            title: "Folder",
            dataIndex: "folder",
            key: "folder",
            width: "15%",
            render: (text, record) => {
                return (
                    <div>
                        {record.stock
                            ?.filter((x) => x.quantity > 0 && x.folder_name)
                            .map((x) => x.folder_name)
                            .join(", ")}
                    </div>
                );
            },
        },
        {
            title: "Price",
            dataIndex: "price",
            key: "price",
            width: "5%",
            align: "right",
            render: (text, record) => {
                if (record.has_variants) {
                    return <div>-</div>;
                }

                return <div>{Number.format(record.price)}</div>;
            },
        },
        {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
            width: "5%",
            align: "right",
            render: (text, record) => <div>{Number.formatInt(record.stock_sum.quantity)}</div>,
        },

        {
            title: "Amount",
            dataIndex: "total_amount",
            key: "total_amount",
            width: "5%",
            align: "right",
            render: (text, record) => <div>{Number.format(record.stock_sum.total_amount)}</div>,
        },
        {
            title: "Tags",
            dataIndex: "tags",
            key: "tags",
            width: "15%",
            render: (text, record) => <Tags tag_ids={record.tags}></Tags>,
        },
        // {
        //     title: "Notes",
        //     dataIndex: "notes",
        //     key: "notes",
        //     width: "80px",
        //     render: (text, record) => <span style={{ display: "-webkit-box", WebkitBoxOrient: "vertical", WebkitLineClamp: 2, overflow: "hidden", overflowWrap: "anywhere" }}>{text}</span>,
        // },
        // {
        //     title: "Lowstock Level ",
        //     dataIndex: "quantity_alert",
        //     key: "quantity_alert",
        //     align: "right",
        //     width: "50px",
        //     render: (text, record) => {
        //         return <span>{record.stock.lowstock_alert ? record.stock.lowstock_alert.quantity : ""}</span>;
        //     },
        // },
        ...renderAllCustomField(),
    ].filter((col) => visibleColumns.includes(col.key));

    return (
        <Card>
            <Table
                rowKey={(record) => record.id}
                loading={loading}
                dataSource={items}
                columns={columns}
                pagination={{
                    current: paging.page,
                    pageSize: paging.pageSize,
                    total: statistic.rows,
                    onChange: (page, pageSize) => {
                        setPaging({ page, pageSize });
                    },
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "50", "100"],
                }}
                expandable={{
                    expandedRowKeys,
                    onExpand: handleExpand,
                }}
                scroll={{
                    x: "max-content",
                }}
            />
        </Card>
    );
}

export default memo(TableListItem);
